import _ from "lodash";
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import withLoader from "UIComponents/GqlWithLoader";
import I18nHOC from "UIComponents/I18nHOC";
import classes from "./RelatedConceptsModal.scss";
import update from "immutability-helper";
import RelatedConceptItem from "./RelatedConceptItem";
import { connect } from "react-redux";
import { graphql, compose } from "lib/apolloClient";
import { getPypRelatedConceptSetFromCache } from "modules/CommonGraphqlHelpers";
import { getPypRelatedConceptSetQuery } from "modules/CommonQuery";
import { getRelatedConceptsGroupedValueOptions } from "UnitPlans/modules/UnitPlanModule";
import { Modal, Button } from "@toddle-edu/ds-web";
class RelatedConceptList extends PureComponent {
  componentDidMount = () => {
    this.props.onComponentMounted();
  };
  render() {
    const {
      relatedConceptSets,
      updateInputField,
      groupedValue,
      groupedOptions,
      updateGroupedState,
      testId,
    } = this.props;
    return (
      <div className={classes.relatedConceptContainer}>
        {_.map(relatedConceptSets, set => {
          const { id, label, isArchived = false } = set;
          const value = groupedValue[id];
          const options = groupedOptions[id];
          return (
            <RelatedConceptItem
              value={value}
              options={options}
              key={id}
              updateInputField={value => updateInputField({ value, key: id })}
              label={label}
              isArchived={isArchived}
              updateGroupedState={value =>
                updateGroupedState({ value, key: id })
              }
              testId={testId}
            />
          );
        })}
      </div>
    );
  }
}

const RelatedConceptListWithLoader = withLoader(RelatedConceptList);

class RelatedConceptsModal extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      groupedValue: props.groupedValue || {},
      groupedOptions: _.cloneDeep(props.groupedOptions) || {},
    };
  }

  onListMounted = () => {
    const { groupedValue, groupedOptions } = this.props;

    this.setState({
      groupedValue: groupedValue || {},
      groupedOptions: _.cloneDeep(groupedOptions),
    });
  };

  componentDidUpdate = (prevProps, prevState) => {
    const { groupedValue: oldGroupedValue } = prevState;
    const { groupedValue } = this.state;
    const { updateValueLocally } = this.props;
    if (groupedValue != oldGroupedValue) {
      if (updateValueLocally) {
        updateValueLocally(groupedValue);
      }
    }
  };

  UNSAFE_componentWillMount = () => {};

  onCancelClick = () => {
    this.props.onCancelClick();
  };

  onAddClick = () => {
    this.props.onAddClick({
      orgRelatedConceptSets: this.props.orgRelatedConceptSets,
      currentGroupedOptions: this.state.groupedOptions,
      groupedOptions: this.props.groupedOptions,
      groupedValue: this.state.groupedValue,
    });
    this.props.onCancelClick();
  };

  updateInputField = ({ value, key }) => {
    let { groupedValue } = this.state;

    groupedValue = update(groupedValue, { [key]: { $set: value } });
    this.setState({ groupedValue });
  };

  updateGroupedState = ({ value, key }) => {
    this.updateInputField({
      value: [...this.state.groupedValue[key], value],
      key,
    });
    const updatedGroupedOptions = this.state.groupedOptions;
    updatedGroupedOptions[key].push(value);
    this.setState({
      groupedOptions: updatedGroupedOptions,
    });
  };

  render() {
    const { groupedValue, groupedOptions } = this.state;
    const {
      relatedConceptSets,
      isData,
      isLoading,
      t,
      testId,
      isEdit,
    } = this.props;

    return (
      <Modal
        hasOverlay={true}
        isOpen={true}
        shouldCloseOnOverlayClick={true}
        shouldCloseOnEsc={true}
        width={"680px"}
        height={"640px"}
        onClose={this.onCancelClick}
      >
        <Modal.Header
          isClosable={true}
          title={t("unitPlan:create_related_concept")}
          testId={testId}
        />
        <Modal.Body isScrollable={true}>
          <RelatedConceptListWithLoader
            relatedConceptSets={relatedConceptSets}
            groupedOptions={groupedOptions}
            groupedValue={groupedValue}
            updateInputField={this.updateInputField}
            isData={isData}
            isLoading={isLoading}
            onComponentMounted={this.onListMounted}
            updateGroupedState={this.updateGroupedState}
            testId={testId}
          />
        </Modal.Body>
        <Modal.Footer hasSeparator={true}>
          <div className={classes.modalFooter}>
            <div className={classes.cancelButton}>
              <Button
                onClick={this.onCancelClick}
                testId={`${testId}-cancel`}
                variant="neutral"
                type="outlined"
                dsVersion="2.0"
              >
                {t("common:cancel")}
              </Button>
            </div>
            <Button
              onClick={this.onAddClick}
              variant="progressive"
              isDisabled={isLoading}
              testId={`${testId}-${isEdit ? `update` : `add`}`}
              dsVersion="2.0"
              shortcut={{
                code: "Enter",
                shiftKey: true,
              }}
              type="fill"
            >
              {this.props.isEdit ? t("common:update") : t("common:add")}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}

const memoizedGetGroupedValueOptions = _.memoize(
  getRelatedConceptsGroupedValueOptions,
  params => JSON.stringify(params)
);

const mapActionCreators = {};

const mapStateToProps = (state, ownProps) => {
  return {
    isData: true,
    isLoading: false,
    organizationId: state.login.userInfo.org_id,
    curriculumId: state.platform.currentCurriculumProgram.id,
  };
};

export default compose(
  connect(mapStateToProps, mapActionCreators),
  I18nHOC({ resource: ["unitPlan", "common"] }),
  graphql(getPypRelatedConceptSetQuery, {
    name: "getRelatedConceptSet",
    skip: ({ subjects, concepts }) =>
      _.get(subjects, "length", 0) == 0 && _.get(concepts, "length", 0) == 0,
    options: ({ subjects, curriculumId, concepts }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        subjects,
        concepts,
        curriculumId,
      },
    }),
    props({
      getRelatedConceptSet,
      ownProps: {
        subjects,
        value,
        curriculumId,
        concepts,
        isData,
        isLoading,
        selectedRelatedConcepts,
        groupedOptionsFields,
      },
    }) {
      const queryData = getPypRelatedConceptSetFromCache({
        subjects,
        curriculumId,
        concepts,
      });
      const relatedConceptSet = _.get(queryData, "plannerElementSets", {});

      const {
        groupedRelatedConcepts,
        groupedValue,
        groupedOptions,
      } = memoizedGetGroupedValueOptions({
        nodes: _.unionBy(
          [
            ..._.get(relatedConceptSet[0], "nodes", []),
            ...selectedRelatedConcepts,
          ],
          "id"
        ),
        subjects,
        value,
        concepts,
        groupedOptionsFields,
      });

      return {
        isData: !_.isEmpty(queryData) && isData,
        groupedRelatedConcepts,
        groupedOptions,
        groupedValue,
        orgRelatedConceptSets: _.get(relatedConceptSet[0], "nodes", []),

        isLoading:
          getRelatedConceptSet["networkStatus"] == 1 ||
          getRelatedConceptSet["networkStatus"] == 2 ||
          isLoading,
      };
    },
  })
)(RelatedConceptsModal);

RelatedConceptsModal.propTypes = {
  updateInputField: PropTypes.func,
  onCancelClick: PropTypes.func,
  name: PropTypes.string,
  isEdit: PropTypes.bool,
};

RelatedConceptsModal.defaultProps = {
  isEdit: false,
};
